import { useLocation } from 'react-router-dom';
import ClioChat from '../components/ClioChat';
import { usePageHeader } from '../shell/pageHeader';

// HD-5: the page frame is the shell's PageHeader + a flush ui-page; the chat body inside is ClioChat, unchanged
// (shared with the Scripts drawer, migrates at HD-7). Help mode arrives as location.state.helpMode.
export default function ProductionAssistant() {
  const location = useLocation();
  const isHelpMode = location.state?.helpMode === true;
  usePageHeader({
    title: 'Clio',
    meta: isHelpMode ? 'Ask anything about how Heliconflow works' : 'Ask anything about your pipeline',
  });
  return (
    <div className="ui ui-page ui-page--flush">
      <ClioChat mode="page" initialHelpMode={isHelpMode} sessionKey="helicon_chat_page" showHeader={false} />
    </div>
  );
}
